import { useRouteMatch } from 'react-router-dom';

export default function usePathMatch() {
    const match = useRouteMatch();
    const { apmId, subViewId, viewId } = match.params;

    const pathReplacements = {
        '/:itemId': '',
        '/edit': '',
        '/new': '',
        ':apmId': apmId,
        ':subViewId': subViewId,
        ':viewId': viewId,
    };

    const collectionPath = match.path.replace(
        new RegExp(Object.keys(pathReplacements).join('|'), 'g'),
        matched => pathReplacements[matched]
    );

    const collectionName = collectionPath.split('/').pop();

    const keyReplacements = [
        {
            replacement: '',
            string: '/:apmId',
        },
        {
            replacement: '',
            string: '/:itemId',
        },
        {
            replacement: '',
            string: '/edit',
        },
        {
            replacement: '',
            string: '/new',
        },
        {
            replacement: subViewId,
            string: ':subViewId',
        },
        {
            replacement: viewId,
            string: ':viewId',
        },
        {
            replacement: '.',
            string: '/',
        },
    ];

    const translationKey = match.path
        .replace(
            new RegExp(keyReplacements.map(obj => obj.string).join('|'), 'g'),
            matched => keyReplacements.find(obj => obj.string === matched).replacement
        )
        .substring(1);

    return {
        collectionName,
        collectionPath,
        translationKey,
    };
}
